module.exports = __webpack_public_path__ + "static/media/north_arrow.c8ab39b4.svg";